<template>
  <b-modal
    :title="$t('openSearch')"
    body-class="open-searches-modal"
    size="lg"
    v-model="localValue"
    header-close-content=""
    @show="showHandler"
    @ok="confirmhandler">
    <div class="open-searches-modal-container" data-cy="advanced-search-open-search-modal">
      <div class="open-searches-modal-filter-container">
        <CommonFilter v-model="vm.filter" :placeholder="$t('FilterByName')" triggerByTime data-cy="advanced-search-filter" />
      </div>
      <div class="open-searches-modal-table-wrapper">
        <table class="table with-sticky-header" v-if="filteredSearches.length" data-cy="advanced-search-filtered-table">
          <thead>
            <tr>
              <th>{{ $t("name") }}</th>
              <th>{{ $t("UpdatedOn") }}</th>
              <th>{{ $t("UpdatedBy") }}</th>
              <th>{{ $t("CreatedOn") }}</th>
              <th>{{ $t("CreatedBy") }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="search in filteredSearches" :key="search.advancedSearchId">
              <tr
                @click="selectSearch(search)"
                @dblclick="confirmhandler"
                :class="{ selected: vm.selectedSearch?.advancedSearchId == search.advancedSearchId }">
                <td>
                  <span class="ellipsis"> {{ search.name }} </span>
                </td>
                <td>{{ getDateTime(search.updatedOn) }}</td>
                <td>
                  <span class="ellipsis">{{ search.updatedBy }}</span>
                </td>
                <td>{{ getDateTime(search.createdOn) }}</td>
                <td>
                  <span class="ellipsis">{{ search.createdBy }}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="empty-state" v-else>
          <Alert class="w-100" with-icon show variant="info">{{ $t("NoSearchesMatchYourFilter") }}</Alert>
        </div>
      </div>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <b-btn @click="ok" variant="primary" :disabled="!vm.selectedSearch" data-cy="advanced-search-open-search-open-btn">{{ $t("Open") }}</b-btn>
      <b-btn @click="cancel" data-cy="advanced-search-open-search-cancel-btn">{{ $t("Cancel") }}</b-btn>
    </template>
  </b-modal>
</template>

<script setup lang="ts">
import Alert from "@common/components/Alert.vue";
import CommonFilter from "@common/components/CommonFilter.vue";
import { AdvancedSearchEntry } from "@medapro-types/AdvancedSearch/AdvancedSearch";
import _ from "lodash";
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";

//#region General

const { d: $d } = useI18n();
const props = defineProps<{ value: boolean; searches: AdvancedSearchEntry[] }>();
const emits = defineEmits(["input", "confirm"]);
//#endregion

//#region Show
const localValue = computed({
  get: () => props.value,
  set: (nv) => emits("input", nv)
});
//#endregion

//#region Viewmodel
type ViewModel = { selectedSearch: AdvancedSearchEntry | null; filter: string };
const vm = reactive<ViewModel>({ selectedSearch: null, filter: "" });
//#endregion

//#region Select
const selectSearch = (entry: AdvancedSearchEntry) => {
  vm.selectedSearch = entry;
};
//#endregion

//#region Filter
const filteredSearches = computed<AdvancedSearchEntry[]>(() => {
  let result = props.searches;

  if (vm.filter?.length) result = result.filter((x) => _.includes(x.name.toLowerCase(), vm.filter.toLowerCase()));

  return result;
});
//#endregion

//#region Transform
const getDateTime = (date: string | null | undefined) => {
  return date ? $d(new Date(date), "shortDateTime") : "";
};
//#endregion

//#region Life
const showHandler = () => {
  vm.selectedSearch = null;
};

const confirmhandler = () => {
  localValue.value = false;
  emits("confirm", vm.selectedSearch);
};
//#endregion
</script>
